import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UsrCred } from "src/app/models/usrcred";
import { VproService } from "src/app/service/vpro/vpro.service";

@Component({
  selector: "app-usr-act-ack",
  templateUrl: "./usr-act-ack.component.html",
  styleUrls: ["./usr-act-ack.component.css"],
})
export class UsrActAckComponent implements OnInit {
  user = new UsrCred();
  submitted = false;
  email_id: any;
  data: any;

  constructor(
    private userService: VproService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params.email_id) {
        this.email_id = params.email_id.replace(" ", "+");
        this.updUsr();
      }
    });
  }

  async updUsr() {
    this.submitted = true;
    this.userService.updUsr(this.email_id).subscribe((data) => {
      this.data = data;
    });
  }
}
